import React from 'react'
import PropTypes from 'prop-types'
import { useApplicationContext } from '../../../../context/ApplicationContext'
import { Message } from '@paypalcorp/worldready-react'
import { useLocation } from 'react-router-dom'
import { SANDBOX_BANNER_EXCLUDED_ROUTES} from '../../../../config/excludedRoutes'

export const TopNavBannerSandbox = ({ label }) => {
  const { enviroment, user } = useApplicationContext()
  const location = useLocation()
  const isSandboxBannerHidden = SANDBOX_BANNER_EXCLUDED_ROUTES.includes(location.pathname)

  return (
    <>
      {enviroment === 'sandbox' && user && !isSandboxBannerHidden && (
        <div className="dev_dash__top-nav-banner-sandbox-line">
          <div className="dev_dash__top-nav-banner-sandbox">
            <Message id={label} />
          </div>
        </div>
      )}
    </>
  )
}
TopNavBannerSandbox.propTypes = {
  label: PropTypes.string,
}